import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";

export default function ImpactBottom(props) {
  const { col } = props;
  const culturalResult = useSelector((state) => state.statehome.culturalResult);
  const environmentResult = useSelector(
    (state) => state.statehome.environmentResult
  );

  return (
    <Col sm={12} style={{ marginTop: "1rem" }}>
      <Row>
        {culturalResult.length ? (
          <Col sm={12} md={12} lg={col[1]} xl={col[0]} xxl={col[0]}>
            <div
              className="card-university"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}
            >
              <div className="card-header">
                <h5>วัฒนธรรม</h5>
                <p>จำนวน {culturalResult.length}</p>
              </div>
              <div className="card-university-body">
                <div className="list">
                  {culturalResult.map((data, index) => (
                    <div className="detail" key={index}>
                      <h6>
                        <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                      </h6>
                      <h6>
                        <b>ปัจจัย :</b> {data.factor_name}
                      </h6>
                      <h6>
                        <b>ประเด็น :</b>{" "}
                        {data.issue_detail.map((rw, i) => (
                          <>
                            {i + 1}
                            {"."}
                            {rw.issue_detail}{" "}
                          </>
                        ))}
                      </h6>
                      <hr className="line-researcher" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        ) : null}

        {environmentResult.length ? (
          <Col sm={12} md={12} lg={col[1]} xl={col[2]} xxl={col[2]}>
            <div
              className="card-university"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}
            >
              <div className="card-header">
                <h5>สิ่งแวดล้อม</h5>
                <p>จำนวน {environmentResult.length}</p>
              </div>
              <div className="card-university-body">
                <div className="list">
                  {environmentResult.map((data, index) => (
                    <div className="detail" key={index}>
                      <h6>
                        <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                      </h6>
                      <h6>
                        <b>ปัจจัย :</b> {data.factor_name}
                      </h6>
                      <h6>
                        <b>ประเด็น :</b>{" "}
                        {data.issue_detail.map((rw, i) => (
                          <>
                            {i + 1}
                            {"."}
                            {rw.issue_detail}{" "}
                          </>
                        ))}
                      </h6>
                      <hr className="line-researcher" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        ) : null}
      </Row>
    </Col>
  );
}
